import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { getCheckinDateBasicConfig, checkinDateDefaultSetting } from './basic-config';
import { areEqual } from '../components/utility';
import { getValidateCheckinDateErrorMsg } from './utility';

export const CheckinDateTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, apiErrors,
  } = props;
  const checkinDateError = value => getValidateCheckinDateErrorMsg({ code: { value }, i18n });

  const handleAddLine = () => {
    const currentLevelSettings = [...data.currentLevelSettings, ...checkinDateDefaultSetting];
    props.setData({ ...data, currentLevelSettings });
  };
  const params = {
    ...getCheckinDateBasicConfig(i18n),
    handleAddLine,
    getFieldErrorMsg: checkinDateError,
    validateParams: { targetId: 'check-in-date-target-wrapper', patchErrMsg, targetName: 'checkinDate' },
    patchTargetsApiErrMsg,
    apiErrors,
  };

  return (
    <div id="check-in-date-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>

  );
}, areEqual);

CheckinDateTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  apiErrors: PropTypes.arrayOf(PropTypes.string),
};
CheckinDateTargetSetting.defaultProps = {
  patchErrMsg() {},
  patchTargetsApiErrMsg() {},
  apiErrors: [],
};
